import React from 'react';

import MaxWidthBox from '@ui/MaxWidthBox';
import PageTitle from '@ui/PageTitle';

import useCms from '@components/Cms/useCms';
import PodcastsGridList from '@components/Media/gridLists/PodcastsGridList';
import RadiosGridList from '@components/Media/gridLists/RadiosGridList';

const ForeignPodcastsPage = () => {
    const cms = useCms();

    return (
        <MaxWidthBox>
            <PageTitle>{cms[5000]}</PageTitle>
            <PodcastsGridList noTitle isForeignLanguage />
            <PageTitle>{cms[5001]}</PageTitle>
            <RadiosGridList noTitle isForeignLanguage />
        </MaxWidthBox>
    );
};

ForeignPodcastsPage.pageConfig = {
    getMeta: (_, cms) => {
        return {
            title: `${cms[5000]} | ${cms[500]}`,
        };
    },
};

export default ForeignPodcastsPage;
